// extracted by mini-css-extract-plugin
export default {"root":"StartPage_root__FOuRK","navigationBlock":"StartPage_navigationBlock__feNfY"};